import { useEffect, useState } from 'react';
import { Box, Fab, IconButton, Paper, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { AutoAwesomeRounded, CloseRounded } from '@mui/icons-material';
import AssistantPanel from './AssistantPanel';

/** The assistant, bottom-right on every screen (Module 0, O11). */
export default function AssistantFab() {
  const [open, setOpen] = useState(false);
  const phone = useMediaQuery(useTheme().breakpoints.down('sm'));

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener('travelerp:open-assistant', show);
    return () => window.removeEventListener('travelerp:open-assistant', show);
  }, []);

  return (
    <>
      {open && (
        <Paper
          elevation={8}
          role="dialog"
          aria-label="Ask the assistant"
          sx={{
            position: 'fixed', zIndex: (t) => t.zIndex.drawer + 2,
            right: { xs: 8, sm: 24 }, bottom: { xs: 8, sm: 92 },
            width: phone ? 'calc(100vw - 16px)' : 380, maxWidth: 'calc(100vw - 16px)',
            borderRadius: 3, p: 2,
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1.5 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <AutoAwesomeRounded color="primary" fontSize="small" />
              <Typography variant="subtitle1" fontWeight={700}>Ask the assistant</Typography>
            </Stack>
            <IconButton size="small" aria-label="Close" onClick={() => setOpen(false)}>
              <CloseRounded fontSize="small" />
            </IconButton>
          </Stack>
          <AssistantPanel onNavigate={() => setOpen(false)} />
        </Paper>
      )}
      <Box sx={{ position: 'fixed', right: { xs: 16, sm: 24 }, bottom: { xs: 16, sm: 24 }, zIndex: (t) => t.zIndex.drawer + 1, display: open && phone ? 'none' : 'block' }}>
        <Tooltip title={open ? 'Close the assistant' : 'Ask the assistant'} placement="left">
          <Fab color="primary" aria-label="Ask the assistant" onClick={() => setOpen((o) => !o)}>
            {open ? <CloseRounded /> : <AutoAwesomeRounded />}
          </Fab>
        </Tooltip>
      </Box>
    </>
  );
}
